import config from 'config';

const initalTheme = localStorage.getItem('themeMode') || 'light';

const initialState = {
  themeMode: initalTheme,

  totalTestCases: 15,

  testCaseResults: ["Passed", "TLE", "Runtime Error", "Passed", "Compile Error", 
                    "Passed", "TLE", "Runtime Error", "Passed", "Compile Error",
                    "Passed", "TLE", "Runtime Error", "Passed", "Compile Error"],

  isEditorReady: false,

  notifications: config.notifications.defaultState,

  editor: {
    selectedLanguageId: 7, // 19 is the id of javasctipt
    options: {
      acceptSuggestionOnCommitCharacter: true,
      acceptSuggestionOnEnter: 'on',
      accessibilitySupport: 'auto',
      autoIndent: false,
      automaticLayout: true,
      codeLens: true,
      colorDecorators: true,
      contextmenu: true,
      cursorBlinking: 'blink',
      cursorSmoothCaretAnimation: false,
      cursorStyle: 'line',
      disableLayerHinting: false,
      disableMonospaceOptimizations: false,
      dragAndDrop: false,
      fixedOverflowWidgets: false,
      folding: true,
      foldingStrategy: 'auto',
      fontLigatures: false,
      formatOnPaste: false,
      formatOnType: false,
      hideCursorInOverviewRuler: false,
      highlightActiveIndentGuide: true,
      links: true,
      mouseWheelZoom: false,
      multiCursorMergeOverlapping: true,
      multiCursorModifier: 'alt',
      overviewRulerBorder: true,
      overviewRulerLanes: 2,
      quickSuggestions: true,
      quickSuggestionsDelay: 100,
      readOnly: false,
      renderControlCharacters: false,
      renderFinalNewline: true,
      renderIndentGuides: true,
      renderLineHighlight: 'all',
      renderWhitespace: 'none',
      revealHorizontalRightPadding: 30,
      roundedSelection: true,
      rulers: [],
      scrollBeyondLastColumn: 5,
      scrollBeyondLastLine: true,
      selectOnLineNumbers: true,
      selectionClipboard: true,
      selectionHighlight: true,
      showFoldingControls: 'mouseover',
      smoothScrolling: false,
      suggestOnTriggerCharacters: true,
      wordBasedSuggestions: true,
      // eslint-disable-next-line
      wordSeparators: `~!@#$%^&*()-=+[{]}\|;:'",.<>/?`,
      wordWrap: 'off',
      wordWrapBreakAfterCharacters: '\t})]?|&,;',
      wordWrapBreakBeforeCharacters: '{([+',
      wordWrapBreakObtrusiveCharacters: '.',
      wordWrapColumn: 80,
      wordWrapMinified: true,
      wrappingIndent: 'none',
    },
  },
  baseURLArkajit:'http://20.198.8.87',
  // baseURLArkajit:'http://sasd',

  baseURL:'http://localhost:8000',

  editorMode: 'editor',

  monacoTheme: initalTheme === 'dark' ? 'vs-dark' : initalTheme,

  diffEditor: {
    selectedLanguageId: 24,  // 24 is the id of markdown
  },

  interviewState:'codingRound',
  interviewId:"02ff1d68-a571-497e-bad8-700fa80354a4",
  codingRoundStarted:false,
  candidateResumeCheckBox:false,
  codingRoundVideoBlobURL:null,
  codingRoundScreenBlobURL:null,
};

export { initialState };
